import _ from 'lodash';

export const SET_OVERLAY = 'mp/overlay/SET_OVERLAY';
export const SET_ALL_OVERLAYS = 'mp/overlay/SET_ALL_OVERLAYS';
export const SET_OVERLAY_DATA = 'mp/overlay/SET_OVERLAY_DATA';
export * from './overlaySelectors';

export const initialState = {
  overlays: {},
  overlayData: {}
};

export const overlay = (state = initialState, action = {}) => {
  switch (action.type) {

    case SET_OVERLAY:
      return {
        ...state,
        overlays: {
          ...state.overlays,
          ...action.payload.overlays
        }
      };

    case SET_ALL_OVERLAYS:
      return {
        ...state,
        overlays: action.payload.overlays
      };

    case SET_OVERLAY_DATA:
      return {
        ...state,
        overlayData: {
          ...state.overlayData,
          ...action.payload.overlayData
        }
      };

    default:
      return state;
  }
};

export const setOverlay = (key, status) => {
  return {
    type: SET_OVERLAY,
    payload: {
      overlays: {
        [key]: status
      }
    }
  };
};

export const setAllOverlays = (overlays, value) => {
  const overlaysWithNewValues = _.mapValues(overlays, () => value);

  return {
    type: SET_ALL_OVERLAYS,
    payload: {
      overlays: overlaysWithNewValues
    }
  };
};

export const setOverlayData = (key, data) => {
  return {
    type: SET_OVERLAY_DATA,
    payload: {
      overlayData: {
        [key]: data,
        overlayName: key
      }
    }
  };
};

export default overlay;



/** WEBPACK FOOTER **
 ** ./client/redux/modules/overlay/overlay.js
 **/